import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { IconX, IconCloudUpload, IconFileText } from "@tabler/icons-react";
import { AppConstant } from "const";

const ImportUserFromExcelDialog = ({ open, onDownload, onClose, onSubmit }) => {
  const { t: getLabel } = useTranslation();

  const [file, setFile] = useState({ name: null, data: null });

  const handleSubmit = () => {
    onSubmit(file.data);
  };

  const handleChangeFile = event => {
    const files = event.target.files;
    const selectedFile = files.length > 0 ? files[0] : null;
    setFile({ name: selectedFile?.name || null, data: selectedFile });
  };

  const handleClose = () => {
    const input = document.getElementById("importUserFromExcel");
    input.value = "";
    setFile({ name: null, data: null });
    onClose();
  };

  if (!open) return null;

  return (
    <>
      <div className="modal-backdrop fade show"></div>
      <div className="modal modal-blur fade show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
          <div className="modal-content" style={{ padding: "16px" }}>
            <div className="modal-header border-0 d-flex align-items-center justify-content-between" style={{ marginBottom: "16px", padding: 0 }}>
              <h5 className="modal-title">{getLabel("TXT_UPLOAD_FILE")}</h5>
              <button className="btn btn-icon btn-ghost-secondary" onClick={handleClose}>
                <IconX size={20} />
              </button>
            </div>
            <div className="modal-body p-0 d-flex flex-column gap-3" style={{ minHeight: "300px" }}>
              <div
                className="d-inline-flex align-items-center gap-2"
                style={{ cursor: "pointer" }}
                onClick={onDownload}
              >
                <IconFileText size={20} color="#1976d2" />
                <span>{getLabel("TXT_DOWNLOAD_SAMPLE_FILE")}</span>
              </div>
              <div className="d-inline-flex align-items-center gap-2">
                <label
                  htmlFor="importUserFromExcel"
                  className="btn btn-sm btn-primary d-inline-flex align-items-center gap-1"
                  style={{ flexShrink: 0 }}
                >
                  {getLabel("TXT_UPLOAD_FILE")}
                  <IconCloudUpload size={16} />
                </label>
                <input
                  hidden
                  type="file"
                  id="importUserFromExcel"
                  accept={AppConstant.IMPORT_USER_FILE_EXTENSIONS.join(",")}
                  onChange={handleChangeFile}
                />
                <span
                  style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                  title={file.name || getLabel("TXT_NOT_FOUND")}
                >
                  {file.name || getLabel("TXT_NOT_FOUND")}
                </span>
              </div>
            </div>
            <div className="modal-footer border-0 p-0 mt-3">
              <button className="btn btn-primary w-100" onClick={handleSubmit} disabled={!file?.data}>
                {getLabel("L_ADD_BUTTON")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ImportUserFromExcelDialog;
